import { constructionAsset, constructionSafety, logisticsAsset } from "@pages/Enterprise/Solution/components/Banner/BannerImages";
import productImg from "../main/product/productImg";
import productPurchase from "../main/product/productPurchase";

export default {
  desc: '산업 4.0 시대에 제조 공장의 관리는 더 이상 수동 모니터링이나 정적 보고서에 의존하지 않습니다. 현대 기술은 공장이 더욱 스마트하고 유연하며 효율적인 새로운 시대를 열었습니다. 이러한 트렌드를 주도하는 뛰어난 솔루션 중 하나가 바로 실시간 위치 추적 시스템(RTLS)입니다. 이 글에서는 RTLS가 무엇인지, 어떻게 작동하는지, 그리고 제조 공장에 가져다주는 큰 이점에 대해 자세히 알아보겠습니다.',
  keywords: '제조 공장, RTLS, 재고 관리, 제조 공장 솔루션',
  ogSite: '실시간 위치추적 시스템을 활용한 스마트 제조공장 관리',
  title: '실시간 위치추적 시스템을 활용한 스마트 제조공장 관리',
  ogUrl: 'https://orbro.io/blog/manufacturingSolution',
  ogImg: 'https://lh3.googleusercontent.com/fife/ALs6j_FBdUF5_5JFZicYztRzaTb32lkY_0RCSL6ZEACdCnqmGxIIbuWyyd226432BrWIxbIXECs-7lvCxwGLHX4XJ9btONBcS48OYJNRy6xfIhNhREOf1g0E27ikS6S4G2Y4Np3qxHVe6QpCuaHCddQ9gTxl1Tpg2BktVTyEzl5ILqVa75lWTkWagZmnQUwe5o-ua9jlmnnxREstUEKSe4qU4o1DbQjaD-Mt9RcGTReJMOR2wnksHbbiJRTvwK9-hBGqAGxXKU9sWmqBBb8VksMoETsUx4t5OTfxG3yRZOAYgHiK9Eg5wrOix4B3ApGHdGGZ9JinM-RLZw2bHlWfGqBYWZtVi32YVmMwzG805mhcKRUhIg5BxrZIyqTFyNBThXwBm7OoxwSndtC2PARwplUzJouibBQ7GTUfMxPv3YRPlVfotFN0TJl1kon_wu33u8gApkqcrUugzDif5-BQhP7HOGba_VA9iCqBpHNZYOipWljn4DjhZLwhvQAK7ehPrzCGOyh-EhunIOMTNcHF_aCSsr0tCtTkzI5aA_FkWkT4uAll50fqP8WrUSQZmTXdx_XM5yyt4L1qO8RRZWU4MCQTrBgjja-ovmpIBy41AvI4NV2Dbg7jgK8ubYiMzqrYXSf9wfwW4pPLOiEOP_AfQTihhVIfstOg92pCQ2fBtNgUcOv_8s_tdFUjeexfBJ5kaAomcp7wcVMmYZvRtw0FwtjD0xkeRYHyU3u6HiIv5eW9AeWCpT7MFtqV3TJWHyvFHVkiIJXFPsLQ2ozWBlr3ZXhdPVMfX5ArdyEJye8DiD4EFiogMXSHGg2Rlk_w9yOGJDVTabbC6oAY6C2xtX1MF92O5yS8TxUNE9ayTW5iY-ivaZd9U4RnS8NNzK9sIAN7CWma8dlnjiyPKoNLZWGlz4V-6XwXSPXJDXlzlWLCfR-524WjsgJL8KGz76Ke1R5ENO14XPz36-LNJWbFs2OcpUs4pVV4OtNEHPqAR-XhrisWIBKi5fLe8kSk9BaDDQL-fFqoEaMbbxImEzWbUYBamXNlMOVL1qEx0ZnFQeHfxfhzxCUBwTuqhAUdTg3R6Ma1OV5QJ5aBQDjmu6docT-Vz5xK4NhqmKMtp0mnrC5_lCvV9COR5Zot_2lHJs-g1KVDHCrRJIpD61tjhdWhAryV7Fu0lkM_kCv6XdUeAKIrOCgj-BnKOBzLARrELSkJkEaJzQaK1EDx0qVnyxxYiTpIUQH66qtajyyPI4fVmouc3KbTSbCHmtR987exMgMzP9Ksv24SzeTvJCPREV1ZW0ptqYTUAlmc_dbPUIKUxSkP4dvXdf6G57IUVMu8yvIS5cU-JZgV1HBhsLxogZ6zxlfCEQfkLjgz0F5HhTyHBj7UGW3AkGV5b7EMAQpL2F8aYyIJ5x2dynb7BNX0Gn2QmA0AOLSo2jXm2L3Eb4r9xDqYuze0UE9H2GzuSFmKTGVlG68_zH6I95-KbmXYuyz7Xk5rtnVA6XPOVtqVyFMAq0Gk9NggiEUBEG83RMXGNajB5GRcs_PEJyXztDJU0TTb5kHaEyWm5_iHgVmNgKGwOG3i0lpI5zY--_NKBsqI0Wlt7frP_5IpmzNakVSeGP9fhCKoOUmBCNtbgavWJkbQtjEBqejePA=w1418-h1414?auditContext=forDisplay',
  ogType: 'website',
  date: '2025-06-19',
  tag1: '#제조공장',
  tag2: '#RTLS',
  tag3: '#재고관리',
  tag4: '#제조공장솔루션',
  text: [
    {
      head: '',
      subHead: '',
      desc: '산업 4.0 시대에 제조 공장의 관리는 더 이상 수동 모니터링이나 정적 보고서에 의존하지 않습니다. 현대 기술은 공장이 더욱 스마트하고 유연하며 효율적인 새로운 시대를 열었습니다. 이러한 트렌드를 주도하는 뛰어난 솔루션 중 하나가 바로 실시간 위치 추적 시스템(RTLS)입니다. 이 글에서는 RTLS가 무엇인지, 어떻게 작동하는지, 그리고 제조 공장에 가져다주는 큰 이점에 대해 자세히 알아보겠습니다.',
      dot: ''
    },
    {
      head: 'RTLS란 무엇이며 제조 공장에서 어떻게 작동하나?',
      subHead: '',
      desc: '실시간 위치 추적 시스템(RTLS)은 기계, 자재, 제품, 심지어 사람까지 실시간으로 정확하게 위치를 추적할 수 있는 기술입니다. RTLS는 RFID(무선 주파수 식별), GPS, 저전력 블루투스(BLE), Wi-Fi와 같은 기술을 사용하여 위치 데이터를 수집하고 중앙 관리 시스템으로 전송합니다.\n\n제조 공장에서 RTLS는 다음과 같은 방식으로 작동합니다:\n\n위치 태그(Tags): 추적해야 할 자산이나 직원에게 부착됩니다.\n\n신호 리더(Readers): 공장 내 전략적 위치에 배치되어 태그에서 데이터를 수집합니다.\n\n관리 소프트웨어: 실시간 데이터를 분석하여 의사 결정을 지원하는 상세 정보를 제공합니다.\n\n예를 들어, 자동차 제조 공장에서는 RTLS를 사용하여 바퀴, 엔진, 좌석과 같은 각 부품을 추적하여 정확한 시간에 올바른 조립 라인으로 이동되도록 보장함으로써 오류와 지연을 최소화합니다.',
      dot: ''
    },
    {
      head: '제조 공장에 대한 RTLS의 구체적인 이점',
      subHead: '',
      desc: 'RTLS의 적용은 제조 공장이 원활하게 운영되고 자원을 최적화하는 데 실질적인 이점을 제공합니다. 다음은 주요 이점입니다.',
      dot: ''
    },
    {
      head: '',
      subHead: '1. 정확한 재고 관리',
      desc: 'RTLS는 제조 공장 내 자재, 반제품, 완제품의 위치와 상태에 대한 종합적인 시각을 제공합니다. 이를 통해 손실을 줄이고, 창고 공간을 최적화하며, 자원이 항상 준비되어 있도록 보장합니다.\n\n실제 사례: 전자 부품 제조 공장은 RTLS를 사용하여 소형 마이크로칩의 위치를 파악함으로써 직원이 신속하게 찾을 수 있도록 도와 조립 라인 준비 시간을 15% 단축했습니다.',
      dot: ''
    },
    {
      head: '',
      subHead: '2. 노동 안전 보장',
      desc: 'RTLS는 직원이 용광로, 유압 프레스, 화학 물질 보관 구역과 같은 위험한區域에 접근할 때 감지하고 경고를 보냅니다. 이는 사람을 보호할 뿐만 아니라 법적 위험과 보험 비용을 줄입니다.\n\n실제 사례: 철강 제조 공장은 RTLS를 사용하여 작업자가 제련소 근처에 있을 때 알림을 보내 안전 관련 사고를 30% 줄였습니다.',
      dot: ''
    },
    {
      head: '',
      subHead: '3. 프로세스 최적화',
      desc: 'RTLS의 실시간 데이터는 관리자가 생산 라인의 병목 현상을 감지하고 적시에 조정하여 생산성을 높일 수 있도록 합니다. 또한 원자재에서 완제품까지 전체 프로세스를 추적하는 데 도움이 됩니다.\n\n실제 사례: 식품 제조 공장은 RTLS를 사용하여 신선한 자재의 보관 시간을 모니터링하여 품질을 보장하고 식품 안전 기준을 준수합니다.',
      dot: ''
    },
    {
      head: '',
      subHead: '4. 장비 유지보수 비용 절감',
      desc: 'RTLS는 기계의 성능과 작동 상태를 추적하여 정기 유지보수 계획을 지원하거나 고장을 예측합니다. 이를 통해 제조 공장은 예기치 않은 다운타임을 피하고 수리 비용을 절감할 수 있습니다.\n\n실제 사례: 제지 공장은 RTLS를 통합하여 절단기의 진동을 측정하고 문제를 조기에 감지하여 연간 유지보수 비용을 25% 절감했습니다.',
      dot: ''
    },
    {
      head: '',
      subHead: '5. 인력 관리 효율성 향상',
      desc: 'RTLS는 제조 공장 내 직원의 위치와 활동을 추적하여 작업 배정을 최적화하고, 대기 시간을 줄이며, 노동 생산성을 높입니다.\n\n실제 사례: 섬유 제조 공장은 RTLS를 사용하여 직원이 천 절단 구역이나 완제품 재봉 구역에서 일하고 있는지 파악하여 유연한 조정을 통해 노동 생산성을 10% 향상시켰습니다.',
      dot: ''
    },
    {
      head: '제조 공장에서 RTLS의 실제 적용 사례',
      subHead: '',
      desc: 'RTLS는 전 세계 제조 공장에서 다양한 실제 적용을 통해 그 가치를 입증했습니다.\n\n자동차 산업: 일본의 Toyota 공장은 RTLS를 사용하여 조립 라인에서 부품을 추적하여 오류를 1% 미만으로 줄이고 생산 속도를 20% 향상시켰습니다.\n\n전자 산업: Samsung은 RTLS를 사용하여 반도체 부품 창고를 관리하여 자재 검색 시간을 몇 초로 단축했습니다.\n\n식품 산업: 유럽의 우유 가공 공장은 RTLS를 사용하여 신선한 우유 컨테이너를 추적하여 적시에 운송하고 제품 품질을 최적화합니다.\n\n이러한 사례는 RTLS가 단순한 기술이 아니라 제조 공장이 글로벌 시장에서 경쟁할 수 있는 지렛대임을 보여줍니다.',
      dot: ''
    },
    {
      head: '결론',
      subHead: '',
      desc: '실시간 위치 추적 시스템(RTLS)은 제조 공장을 스마트하고 효율적이며 안전한 생태계로 전환하는 열쇠입니다. 정확한 재고 관리, 프로세스 최적화, 노동 안전 강화, 운영 비용 절감에 이르기까지 RTLS는 모든 기업이 간과할 수 없는 탁월한 가치를 제공합니다.\n\n지금 바로 RTLS를 탐구하고 적용하여 제조 공장을 새로운 차원으로 끌어올리고, 산업 4.0 시대에서 경쟁할 준비를 하세요!',
      dot: ''
    }
  ],

  link: {
    page: 'rtls',
    numb: '2',
    product: [
      {
        text: productPurchase.purchase.worker.workerTracking.title,
        title: productPurchase.purchase.worker.workerTracking.title,
        serial: productPurchase.purchase.worker.workerTracking.serial,
        desc: 'UWB 단말기를 작업자 또는 장비에 부착하여, 실시간으로 위치 추적을 돕는 제품입니다.',
        img: productImg.product.workerTracking.thumbnail,
      },
      {},
    ],

    solution: [
      {
        img: constructionAsset.thumb,
        data: 'constructionAsset',
        link: '/enterprise/construction/asset',
      },
      {
        img: constructionSafety.thumb,
        data: 'constructionSafety',
        link: '/enterprise/construction/safety',
      },
      {
        img: logisticsAsset.thumb,
        data: 'logisticsAsset',
        link: '/enterprise/logistics/asset',
      },
    ],
  },
};
